// General
function hideElement(el) {
  el.style.opacity = 0;
  el.classList.add('hidden');
  el.setAttribute('hide', '');
}

function showElement(el) {
  el.style.opacity = 1;
  el.classList.remove('hidden');
  el.removeAttribute('hide');
}

function disableInput(input) {
  input.disabled = true;
  input.classList.add('disabled');
}

function enableInput(input) {
  input.disabled = false;
  input.classList.remove('disabled');
}

function formatCurrency(value) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

  return formatter.format(value);
}
  

class SubscriptionPicker extends HTMLElement {
  connectedCallback() {
    this.init();
    
     this.unsubscribe = subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      this.onVariantChange.bind(this)
    );
  }

  disconnectedCallback() {
    this.unsubscribe?.();
  }

  init() {
    this.variants = this.getScriptJson().variants;
    this.shippingFrequencies = this.querySelectorAll('.shipping-frequency');
    this.shippingFooter = this.querySelector('.subscription-footer');
    this.options = Array.from(
        this.querySelectorAll('variant-selects .subscription-variants .option-content input[type="radio"]')
      ).map(op => ({ 
        id: op.dataset.optionValueId, 
        title: op.value 
      })
    );

    const variantId = this.dataset.variantId;
    const variant = this.variants.find(v=> v.id === variantId);
    this.subscriptionFrequency(variant, false);
  }

  getScriptJson() {
    try {
      const scriptTag = this.querySelector(`#ProductJSON-${this.dataset.productId}`);

      if (!scriptTag) {
        console.error("Elemento script não encontrado");
        return null;
      }

      const jsonString = scriptTag.textContent.trim();

      if (!jsonString) {
        console.error("O conteúdo do script está vazio");
        return null;
      }
      if (!jsonString.startsWith("{") || !jsonString.endsWith("}")) {
        throw new Error("Formato JSON inválido");
      }

      return JSON.parse(jsonString);
    } catch (e) {
      console.error("Erro ao parsear JSON:", e);
      console.error("Conteúdo problemático:", scriptTag.textContent);
      return null;
    }
  }

  subscriptionFrequency(variant, hasFocus = true) {
    const days = variant.subscription_frequency;

    if (days === 0) {
      this.shippingFooter.classList.add('hidden');
      return;
    }
    this.changeDate(variant.subscription_frequency);
    if (this.shippingFooter.classList.contains('hidden')) this.shippingFooter.classList.remove('hidden');
    if (hasFocus) {
      setTimeout(()=> {
        this.shippingFooter.scrollIntoView({ behavior: 'smooth', block: 'end'})
      }, 800);
    }
  }

  onVariantChange({ data }) {
    if (!this.shippingFooter) return;

    const { selectedOptionValues } = data;
    const selectedOption = this.options.find(op => op.id === selectedOptionValues[0]);
    const variant = this.variants.find(v=> v.title.toLowerCase() === selectedOption.title.toLowerCase());

    this.subscriptionFrequency(variant);
  }

  changeDate(days) {
    const updateEl = (i, el, shippingDate) => {
      const titleEl = el.querySelector('.title');
      titleEl.textContent = `${i}º ${titleEl.dataset.value}`;


      const dateEl = el.querySelector('.date');
      dateEl.textContent = shippingDate;
    }

    const daysOrMonths = days => {
      const months = days / 30;
      if (Number.isInteger(months)) return new Date(now.setMonth(now.getMonth() + months));
      return new Date(now.setDate(now.getDate() + days))
    }

    const now = new Date(); 

    for (const [i, el] of this.shippingFrequencies.entries()) {
      const index = i + 1;
      const shippingDate = index === 1 
        ? new Date(now).toLocaleDateString('pt-BR')
        : daysOrMonths(days).toLocaleDateString('pt-BR');
      
        updateEl(index, el, shippingDate);
    }
  }
}

if (!customElements.get("subscription-picker")) {
  customElements.define('subscription-picker', SubscriptionPicker);
}

class SwiperContainer extends HTMLElement {
  connectedCallback() { 
    this.totalSlides = this.querySelectorAll('.swiper-slide').length;
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
    }
  }

  initSwiper() {
    let opts = {};
    try {
      let rawOpts = this.dataset.swiperOptions;
      if (rawOpts && rawOpts.trim() !== '') {
        opts = JSON.parse(rawOpts);
      }
    } catch (e) {
      console.error('Erro ao ler data-swiper-options:', e);
    }

    let transitionEffect = this.dataset.transitionEffect || 'slide';
    opts.effect = transitionEffect;
    
    if (this.dataset.autoHeight !== undefined) {
        opts.autoHeight = this.dataset.autoHeight === 'true';
    }

    if (transitionEffect === 'fade') {
      opts.fadeEffect = { crossFade: true };
      opts.slidesPerView = 1;
      opts.slidesPerGroup = 1;
    }
    
    const elPagination = this.querySelector('.swiper-pagination')
    if (elPagination) {
      opts.pagination = {
        el: elPagination,
        clickable: true
      };
    }

    const swiperButtons = this.querySelector('.swiper-buttons');
    if (swiperButtons && swiperButtons.children.length == 2) {
      const nextButton = swiperButtons.querySelector('.swiper-button-next');
      const prevButton = swiperButtons.querySelector('.swiper-button-prev');
      opts.navigation = {
        nextEl: nextButton,
        prevEl: prevButton
      };
    }
    
    opts.resizeObserver = false;
    this.swiper = new Swiper(this, opts);
    // requestAnimationFrame(() => {
    //   requestAnimationFrame(() => {
    //   });
    // });
  }
}

if (!customElements.get("swiper-container")) {
  customElements.define("swiper-container", SwiperContainer);
}

class ProductSubscription extends HTMLElement {
  connectedCallback() {
    this.init();
    
     this.unsubscribe = subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      this.onVariantChange?.bind(this)
    );
  }

  disconnectedCallback() {
    this.unsubscribe?.();
  }

  init() {
    this.subscriptionQuantity = 1;
    this.subscriptionContainer = this.querySelector('.purchase-type:has(input[data-type="subscription"])');
    this.priceTag = this.subscriptionContainer.querySelector('.price-item--last');
    
    const purchaseContainer = this.querySelector('.purchase-container');
    this.subscriptionFooter = this.querySelector('.subscription-footer ');
    
    this.productForm = this.closest('product-info')?.querySelector(`#${this.dataset.productFormId}`);
    this.variantIdInput = this.productForm?.querySelector('input[name="id"]');
    this.propertyInput = this.productForm?.querySelector('input[name="properties[_url]"]');

    const quantityInputContainer = this.closest('product-info')?.querySelector('.product-form__quantity');
    this.quantityInput = quantityInputContainer?.querySelector('.quantity__input');
    this.quantityButtons = quantityInputContainer?.querySelectorAll('.quantity__button');
    
    this.isOpen = false;
    this.subscriptionSelected = false;
    const button = this.querySelector('.button');
    const radios = this.querySelectorAll('input[type="radio"]');
    const select = this.querySelector('select[data-subscription-select]');

    if (!radios.length) return;
    if (!select && !this.dataset?.onlyChoice) return;
  
    
    for (const radio of radios) {
     radio.addEventListener('change', () => this.handleRadio(radio, select, radios)); 
    }

    if(!this.dataset?.onlyChoice) {
      const options = Array.from(select.querySelectorAll('option'));
      select?.addEventListener('change', (event) => this.handleSelect(event, options));
    } 

    
    if (!button) 
      this.handleButton(false, purchaseContainer, radios, this.dataset?.defaultType);
    else
      button.addEventListener('click', () => this.handleButton(button, purchaseContainer, radios));
  }

  handleSelect(e, options) {
    const value = e.target.value;
    this.setProduct(value);

    if(!options) return;

    const selectedOption = options.find(o => o.value == value);
    const price = Number(selectedOption.dataset.price);
    const compareAtPrice = Number(selectedOption.dataset.compareAtPrice);
  
    this.changePriceTag(formatCurrency(price));
  }

  handleQuantityInput = ({ enable = false, isSubscription = false }) => {
    if (!this.quantityInput) return;
    
    if (enable) enableInput(this.quantityInput);
    else disableInput(this.quantityInput);

    if (isSubscription) this.quantityInput.value = this.subscriptionQuantity;

    this.quantityButtons?.forEach(button => {
      if (enable) enableInput(button);
      else disableInput(button);
    });
  }

  handleRadio(radio, select, radios) {
    if (!radio.checked) return;

    radios.forEach(r => 
      r.checked 
      ? r.closest('label')?.classList.add('active') 
      : r.closest('label')?.classList.remove('active')
    );  

    if (radio.dataset.type.toLowerCase() == 'once') {
      this.subscriptionSelected = false;
      this.handleQuantityInput({enable:true});
      hideElement(this.subscriptionFooter);
      this.setProduct(radio.value, false);
      return;
    }

    this.handleQuantityInput({isSubscription:true});
    this.subscriptionSelected = true;
    showElement(this.subscriptionFooter);

    this.dataset?.onlyChoice 
      ? this.setProduct(this.dataset?.onlyChoice)
      : this.setProduct(select.value);
  }

  handleButton(button, purchaseContainer, radios, type = 'subscription') {
    this.isOpen = !this.isOpen;
    
    const selectRadio = (radios, type) => {
      radios.forEach(radio => {
        radio.dataset.type.toLowerCase() == type.toLowerCase()
        ? radio.checked = true
        : radio.checked = false;

        radio.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      });
    } 

    if (this.isOpen) {
      if (purchaseContainer) showElement(purchaseContainer);
      if (button) hideElement(button);

      if(!radios) return;

      purchaseContainer.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      selectRadio(radios, type);
      return;
    }

    selectRadio(radios, 'once');
    hideElement(purchaseContainer);
  }

  setProduct(id, subscription = true) {
    if (!this.variantIdInput) return;

    this.variantIdInput.value = id;
    this.variantIdInput.setAttribute("data-subscription", "true");

    this.variantIdInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );

    // Alterar existêcia do input de property[_url] caso o produto seja ou não de assinatura
    // Produtos de compra única não precisa ter o property, ou serão separados no carrinho de adições por outras fontes que a página do produto.
    // Como os outros componentes/seções tem buy-buttons próprios, eles não estão enviando a propriedade vazia - essa solução é mais simples para o momento.
    if (subscription) {
      if (!this.productForm.querySelector('input[name="properties[_url]"]')) return;
      this.productForm.appendChild(this.propertyInput);
    }
    else this.productForm.removeChild(this.propertyInput);
  }

  changePriceTag(value) {
    this.priceTag.textContent = value;
  }
}

if (!customElements.get("product-subscription")) {
  customElements.define('product-subscription', ProductSubscription);
}